import { gsap } from "gsap";
import PageAIRevolutionVideosCTA from "./PageAIRevolutionVideosCTA";
import PageAIRevolutionHero from "./PageAIRevolutionHero";
import AiRevolutionHeroSVG from "./AiRevolutionHeroSVG";
import AiRevolutionTeam from "./AiRevolutionTeam";

class PageAIRevolution {
    constructor() {
        AiRevolutionHeroSVG.init();
        PageAIRevolutionHero.init();
        PageAIRevolutionVideosCTA.init();

        const revolutionTeamItems = document.querySelectorAll('.ai-rev-thumb')
        if(revolutionTeamItems.length) {
            gsap.fromTo(revolutionTeamItems, {
                opacity: 0,
                y: "+= 50",
            }, {
                duration: 1,
                opacity: 1,
                y: 0,
                ease: 'power2.out',
                stagger: 0.25,
                delay: .25,
            });
        }

        const revolutionTeam = document.querySelectorAll('[data-revolution-team]')
        if(revolutionTeam.length) {
            revolutionTeam.forEach((team) => {
                new AiRevolutionTeam(team);
            })
        }
    }
}
export default PageAIRevolution;
